<template>
  <view-with-location>
    <v-container class="pa-0 pr-2">
      <v-row no-gutters dense>
        <v-col cols="1">
          <report-download
            :reportType="'agreement'"
            v-if="locationCount && locationDetail.active"
          />
        </v-col>
        <v-col cols="1">
          <v-container class="pa-0 my-0" v-if="showCreateAgreement">
            <v-fab-transition>
              <v-btn
                @click="mobileCreateDialog = true"
                color="primary"
                class="ma-2 top-right-agreements-mobile"
                :dark="true"
                fab
                small
                elevation="3"
                v-if="isMobile"
                :disabled="!locationCount || !locationDetail.active"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
              <v-btn
                @click="desktopCreateDialog = true"
                color="primary"
                class="ma-2 top-right-agreements pr-6"
                depressed
                rounded
                v-if="!isMobile && locationDetail.active"
                :disabled="!locationCount"
                style="
                  min-height: 40px !important;
                  width: 210px !important;
                  font-weight: 500 !important;
                "
              >
                <v-icon
                  large
                  style="color: white !important; font-size: 1.5rem !important"
                  class="pr-2"
                >
                  mdi-plus
                </v-icon>
                Neue Vereinbarung
              </v-btn>
            </v-fab-transition>
          </v-container>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      :class="
        isMobile
          ? 'pa-3 mobile-agreements mb-12'
          : 'pa-3 mt-6 my-0 px-0 scrolly fat-margin-bottom'
      "
    >
      <v-row v-if="!locationCount">
        <v-container style="text-align: center; margin-top: 40px">
          <div class="missing-locations--icon"></div>
          <p class="pb-1 font-weight-bold" style="font-size: 1.2rem">
            Kein Standort vorhanden
          </p>
          <p class="mt-0" v-if="!isMobile">
            Bitte legen Sie im ersten Schritt einen Standort an.
          </p>
          <p class="mt-0" v-if="isMobile">
            Bitte legen Sie im ersten <br />
            Schritt einen Standort an.
          </p>

          <v-btn
            color="primary"
            depressed
            rounded
            :to="{ name: 'LocationCreate' }"
          >
            <v-icon
              large
              style="color: white !important; font-size: 1.5rem !important"
              class="pr-1"
            >
              mdi-plus
            </v-icon>
            Neuer Standort
          </v-btn>
        </v-container>
      </v-row>
      <v-row dense v-if="locationDetail.id && !locationDetail.agreements"
        ><v-container style="text-align: center; margin-top: 40px">
          <div class="missing-locations--icon"></div>
          <p class="pb-1 font-weight-bold" style="font-size: 1.2rem">
            Ihre Vereinbarungen
          </p>
          <p class="mt-0" v-if="!isMobile">
            Sie haben noch keine aktiven Verbeinbarungen am ausgewählten
            Standort.
          </p>
          <p class="mt-0" v-if="isMobile">
            Sie haben noch keine aktiven <br />
            Verbeinbarungen am ausgewählten Standort.
          </p>
        </v-container>
      </v-row>
      <v-row
        class="d-flex locationList"
        :dense="tinyList"
        v-if="locationDetail.active"
        :class="{ 'px-4': !isMobile }"
        data-cy="agreement-chip"
      >
        <v-col
          :class="
            isMobile
              ? 'col-12 px-2 py-1'
              : isMediumDevice
              ? 'col-4 pa-3'
              : 'col-3 pa-4'
          "
          v-for="(agreement, i) in validAgreements"
          :key="i"
          class="d-flex dash-card"
        >
          <agreement :agreement="agreement" :key="componentKey" />
        </v-col>
      </v-row>
    </v-container>

    <v-bottom-sheet
      v-model="mobileCreateDialog"
      max-width="500"
      v-if="isMobile"
    >
      <create-agreement
        :key="componentKey"
        :isMobile="isMobile"
        :schema="schema"
        @done-add-successfully="closeDialogAndReload"
        @close-add-dialog="closeDialog"
      />
    </v-bottom-sheet>
    <v-dialog
      v-model="desktopCreateDialog"
      max-width="500"
      v-if="!isMobile"
      persistent
    >
      <create-agreement
        :key="componentKey"
        :isMobile="isMobile"
        :schema="schema"
        @done-add-successfully="closeDialogAndReload"
        @close-add-dialog="closeDialog"
      />
    </v-dialog>
  </view-with-location>
</template>
<script>
import Vue from "vue";
import ViewWithLocation from "@/components/ViewWithLocation.vue";
import { mapGetters, mapState } from "vuex";

import ReportDownload from "@/components/ReportDownload";
import Agreement from "@/components/Agreement.vue";
import CreateAgreement from "@/components/CreateAgreement.vue";
import axios from "axios";
import { ApiUrl } from "@/config/ApiUrl";

export default Vue.extend({
  components: {
    ViewWithLocation,
    Agreement,
    ReportDownload,
    CreateAgreement,
  },
  data: () => {
    return {
      mobileCreateDialog: false,
      desktopCreateDialog: false,
      componentKey: 0,
      schema: {
        agreementTypes: [],
        wasteTypes: [],
        containerTypes: [],
      },
    };
  },
  mounted() {
    if (this.userIsAgreementManager) {
      axios.get(ApiUrl.TYPES_AGREEMENT_CREATE).then((schema) => {
        this.schema = schema.data;
        this.schema.containerTypes.forEach((container) => {
          container.label = `${container.size} ${container.type}${
            container.extra ? " " + container.extra : ""
          }`;
          container.sizeLabel = `${container.size} ${
            container.extra ? " " + container.extra : ""
          }`;
        });
      });
      this.$store.dispatch("getTypesForAgreement");
    }
    this.$store.dispatch("getCompanyUiFields");
  },
  watch: {
    mobileCreateDialog(value) {
      if (value !== true) {
        this.componentKey += 1;
      }
    },
    desktopCreateDialog(value) {
      if (value !== true) {
        this.componentKey += 1;
      }
    },
  },
  computed: {
    ...mapState({
      locations: (state) => state.company.locations,
      locationDetail: (state) => state.company.locationDetail,
      orderCount: (state) => state.company.orderCount,
      user: (state) => state.user,
      schema: (state) => state.company.typesForAgreement,
    }),
    ...mapGetters({
      locationCount: "locationCount",
      userIsAgreementManager: "userIsAgreementManager",
    }),
    validAgreements() {
      if (!this.locationDetail || !this.locationDetail.agreements) {
        return [];
      }
      return this.locationDetail.agreements.filter(
        (agreement) =>
          agreement.containerType.type === "Lose Abholung" || agreement.amount
      );
    },
    showCreateAgreement() {
      return (
        this.$store.getters.userIsAgreementManager && this.locationDetail?.id
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
    tinyList() {
      return this.$vuetify.breakpoint.width < 440;
    },
    isMediumDevice() {
      return (
        this.$vuetify.breakpoint.width < 1280 &&
        this.$vuetify.breakpoint.width > 767
      );
    },
  },
  methods: {
    closeDialogAndReload() {
      this.$toast("Vielen Dank! Der Auftrag wurde entgegen genommen.");
      this.mobileCreateDialog = false;
      this.desktopCreateDialog = false;
      this.$store.dispatch("getLocationDetail", this.locationDetail.id);
    },
    closeDialog() {
      this.mobileCreateDialog = false;
      this.desktopCreateDialog = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.top-right-agreements
  position: absolute
  right: 0.8rem
  top: 0
  z-index: 5

.top-right-agreements-mobile
  position: fixed
  right: 5vw
  bottom: 9vh
  z-index: 5
.mobile-agreements
  background-color: #DDDCE2 !important
  padding-top: 62px !important
  min-height: 100vh

.missing-locations--icon
  background-image: url('../assets/IconNoLocations.svg')
  background-repeat: no-repeat
  width: 150px
  height: 150px
  margin: 0 auto
.hide-me
  display: none

@media (max-width: 439px)
  .mobile-agreements .dash-card
    padding-right: 1px !important
    padding-left: 1px !important
</style>
